import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import { SANDBOX_BACKGROUND, SummaryBox } from '../../common/components/SummaryBox';
import { InstancesCounters } from '../models/valueObjects/InstancesCounters';

type Props = {
  counters: InstancesCounters;
};

export const Summary = ({ counters }: Props) => {
  const all = counters.getAll();
  const passed = counters.getPassed() + counters.getNotKept();
  const failed = all - passed;
  const inPolicy = all === 0 ? 0.0 : (passed / all) * 100;
  const outOfPolicy = all === 0 ? 0.0 : (failed / all) * 100;

  return (
    <Box sx={{ height: 1, p: 2, borderRadius: '4px', background: SANDBOX_BACKGROUND }}>
      <Typography variant="overline" sx={{ fontWeight: 500, color: 'text.secondary' }}>
        {t('summary')}
      </Typography>
      <Box sx={{ mt: 5 }}>
        <Box sx={{ display: 'inline-block', width: '50%', pr: 1.25 }}>
          <SummaryBox label={`${t('inPolicy')}:`} value={inPolicy} color={'success.main'} />
        </Box>
        <Box sx={{ display: 'inline-block', width: '50%' }}>
          <SummaryBox label={`${t('outOfPolicy')}:`} value={outOfPolicy} />
        </Box>
      </Box>
    </Box>
  );
};
